import { useTranslation } from 'react-i18next';
import { Button, Collapse, Drawer, Form, Radio, Space, TableColumnsType, TableProps, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import "./index.scss"
import { isEmpty, size } from 'lodash'
import { getDetailBasicAdminAccount } from '../../../service/management-participate-platform'

type Props = {
  open: boolean
  onClose: () => void
  detailData: any
}

export default function DetailBasicAccountAdminDrawer(props: Props) {
  const { t } = useTranslation();
  const { open, onClose, detailData } = props
  const [form] = Form.useForm()
  const { Panel } = Collapse;

  const [listTableDataDetail, setListTableDataDetail] = useState<any>([])
  const [status, setStatus] = useState<any>([])
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [statusOrder, setStatusOrder] = useState<string>("")
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("")
  const [dataDetail, setDataDetail] = useState<any>({})

  const getListDataDetail = async () => {
    await getDetailBasicAdminAccount(detailData?.id).then((res) => {
      if (res.status === 200) {
        setDataDetail(res.data?.data)
      }
    })
  }

  useEffect(() => {
    if (open) {
      getListDataDetail();
    }
  }, [open]);

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  return (
    <Drawer
      title={t("Xem chi tiết tài khoản quản trị cơ sở", "Xem chi tiết tài khoản quản trị cơ sở")}
      open={open}
      onClose={onClose}
      className='detail-basic-account-admin-drawer'
      width={736}
      bodyStyle={{ padding: "0px" }}
      extra={
        <Space>
          <Button onClick={onClose}>{t("Đóng", "Đóng")}</Button>
        </Space>
      }
    >
      <Form
        className="detail-basic-account-admin"
        layout={"vertical"}
        form={form}
        name="form-detail-basic-account-admin"
      >
        <div>
          <Collapse defaultActiveKey={["1", "2"]}>
            <Panel
              header={t("Thông tin liên hệ của tài khoản", "Thông tin liên hệ của tài khoản")}
              key="1"
              className="setting-chapter-title">
              <div className='m-5'>
                <span className='flex'><Typography.Title level={5} className='min-w-[160px]'>{t("Yêu cầu thiết lập tham gia tài khoản", "Yêu cầu thiết lập tham gia tài khoản")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.universityRegisterName}</p></span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Người liên hệ", "Người liên hệ")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.userContact}</p></span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Chức vụ", "Chức vụ")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.userContactPositionName}</p></span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Số điện thoại", "Số điện thoại")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.userContactPhone}</p></span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Email liên hệ", "Email liên hệ")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.userContactEmail}</p></span>
              </div>
            </Panel>

            <Panel
              header={t("Thông tin tài khoản", "Thông tin tài khoản")}
              key="2"
              className="setting-chapter-title">
              <div className='m-5'>
                <span className='flex'><Typography.Title level={5} className='min-w-[160px]'>{t("Cơ sở đào tạo", "Cơ sở đào tạo")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.unitName}</p></span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Email đăng nhập", "Email đăng nhập")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.username}</p></span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Vai trò", "Vai trò")}</Typography.Title>
                  <p className='mt-0.5 ml-2'>
                    {dataDetail?.roles?.map((item: any) => item?.name).join(', ')}
                  </p>
                </span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Trạng thái", "Trạng thái")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.isActive ? t("Mở khóa", "Mở khóa") : t("Khóa", "Khóa")}</p></span>
              </div>
            </Panel>
          </Collapse>
        </div>
      </Form>
    </Drawer>
  )
}
